import { BlankLoadingPage } from '@/app/components/pages/BlankLoadingPage'
import { useAuthLogout } from '@/app/hooks/auth/useAuthLogout'
import { useAuthVerify } from '@/app/hooks/auth/useAuthVerify'
import { isValidRedirect } from '@/app/lib/auth'
import { ROUTES } from '@/app/lib/constants'
import { useCallback, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function AuthLoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { mutateAsync: verifyToken } = useAuthVerify()
  const { mutateAsync: logout } = useAuthLogout()

  const urlToken = searchParams.get('token')

  const fetchToken = useCallback(async () => {
    try {
      const redirectToParams = searchParams.getAll('redirectTo')
      const validRedirects = redirectToParams.filter(isValidRedirect)

      if (urlToken) {
        const {
          data: { accessToken },
        } = await verifyToken({
          token: urlToken,
        })

        if (!accessToken) {
          throw new Error('Invalid token')
        }

        if (!validRedirects[0]) {
          window.location.href = ROUTES.homepage
          return
        }

        const finalUrl = new URL(validRedirects[0], window.location.origin)

        if (validRedirects[1]) {
          finalUrl.searchParams.set(
            'redirectTo',
            encodeURIComponent(validRedirects[1])
          )
        }

        window.location.href = finalUrl.toString()
      }
    } catch {
      try {
        await logout()
      } catch {
        // Ignore logout errors
      } finally {
        navigate(ROUTES.login, { replace: true })
      }
    }
  }, [searchParams, urlToken, verifyToken, logout, navigate])

  useEffect(() => {
    fetchToken()
  }, [fetchToken])

  return <BlankLoadingPage />
}
